import { FilterType, ListView, ListViewColumnType, initListView } from '../../UI/view/list-view';
import { myRecentOrdersDS, ordersPermissions } from './orders-datasource';
import { OrderType, isDewarOnlyFilter, ordersListDebounce } from './orders-types';
import { getSourcePlantOptions } from '../../../services/requests/orders/orders-requests';

// Legacy gvMyRecentOrders ("My Recently Changed Orders"). Legacy binds the current
// user's orders modified in the last day (ModifiedOn desc) and applies only the
// Source Plant (HDC) filter — no order-type filter.
// Order Number	Booking ID	Customer Name	Port Cutoff	Date Requested	City	State	Container #	Location	Source Plant	Delivery Type	PO #/Ord ID	Order Type
export const myRecentOrdersListView = {
  permissions: ordersPermissions,
  addButtonText: 'Create Order',
  addButtonPath: '/orders/create',
  filterGroup: 'orders',
  ...ordersListDebounce,
  filters: [
    {
      fieldName: 'shippingLocationName',
      type: FilterType.combo,
      label: 'Source Plant',
      searchable: true,
      options: getSourcePlantOptions,
      serverExpression: 'ShippingLocation.LocationName == @val',
      valExpression: (val) => '"' + val + '"',
    },
  ],
  columns: [
    {
      Header: 'Customer Name',
      accessor: 'customerName',
      type: ListViewColumnType.linkEdit,
      linkPath: ({ row }) => `/orders/edit/${row?.original?.id}`,
      excludeGlobalFilter: true,
      serverExpression:
        '(OrderTypeId == 1 ? GasCustomer.CustomerName : (OrderTypeId == 2 ? LiquidCustomer.CustomerName : (OrderTypeId == 3 ? DewarCustomer.AccountName : "")))',
    },
    {
      Header: 'Order Number',
      accessor: 'orderNumber',
      excludeGlobalFilter: true,
    },
    { Header: 'Booking ID', id: 'bookingId', excludeGlobalFilter: true, accessor: ({ bookingId }) => (bookingId ? bookingId : '') },
    {
      Header: 'Port Cutoff',
      id: 'portCutoff',
      disableSortBy: true,
      excludeGlobalFilter: true,
      accessor: ({ bookingPortCutoffDateString }) => bookingPortCutoffDateString || '',
    },
    { Header: 'Date Requested', accessor: 'dateRequested', excludeGlobalFilter: true, type: ListViewColumnType.date },
    { Header: 'City', accessor: 'city', excludeGlobalFilter: true },
    { Header: 'State', accessor: 'state', excludeGlobalFilter: true },
    { Header: 'Container #', accessor: 'containerId', excludeGlobalFilter: true },
    {
      Header: 'Location',
      id: 'shippingCountry',
      excludeGlobalFilter: true,
      serverExpression: 'ShippingLocation.ResidentCountry',
      accessor: ({ shippingLocation }) => shippingLocation?.residentCountry || '',
    },
    {
      Header: 'Source Plant',
      id: 'shippingLocationName',
      excludeGlobalFilter: true,
      serverExpression: 'ShippingLocation.LocationName',
      accessor: ({ shippingLocation }) => shippingLocation?.locationName || '',
      filter: 'equals',
    },
    {
      Header: 'Delivery Type',
      id: 'deliveryType',
      excludeGlobalFilter: true,
      serverExpression: 'DeliveryType.Name',
      accessor: ({ deliveryType }) => deliveryType?.name || '',
    },
    {
      Header: 'PO #/Ord ID',
      id: 'ponumber',
      excludeGlobalFilter: true,
      accessor: ({ ponumber, orderId }) => orderId || ponumber || '',
    },
    {
      Header: 'Order Type',
      id: 'orderType',
      excludeGlobalFilter: true,
      serverExpression: 'OrderTypeId',
      accessor: ({ orderTypeId }) =>
        orderTypeId === OrderType.Gas
          ? 'Gas'
          : orderTypeId === OrderType.Liquid
          ? 'Liquid'
          : orderTypeId === OrderType.Dewar
          ? 'Dewar'
          : '',
    },
    {
      Header: 'Manifest',
      id: 'manifest',
      disableSortBy: true,
      excludeGlobalFilter: true,
      show: (_viewOptions, filtersState) => isDewarOnlyFilter(filtersState),
      accessor: ({ dewarManifestLine }) => dewarManifestLine || '',
    },
    // Hidden, search-only columns: global search limited to id fields. Numeric
    // columns use .ToString() so the backend string(object(..)) wrapper doesn't
    // blow up casting an int to a string.
    { Header: 'Order # (search)', id: 'orderNumberSearch', accessor: 'orderNumber', serverExpression: 'OrderNumber.ToString()', hidden: true },
    { Header: 'Order Id (search)', id: 'orderIdSearch', accessor: 'orderId', hidden: true },
    { Header: 'Customer # (search)', id: 'customerIdSearch', accessor: 'customerId', serverExpression: 'CustomerId.ToString()', hidden: true },
    // Customer name is globally searchable via a COALESCE (not the ternary the
    // display column uses for sort) so it survives the backend string(object(..))
    // global-search wrapper.
    { Header: 'Customer Name (search)', id: 'customerNameSearch', accessor: 'customerName', serverExpression: 'GasCustomer.CustomerName ?? LiquidCustomer.CustomerName ?? DewarCustomer.AccountName', hidden: true },
  ],
} as ListView;

export const MyRecentOrdersList = initListView(myRecentOrdersListView, myRecentOrdersDS);
